/* ---------------------------------- */

/*
 * 	Steelcase
 * 	Workplace Solutions
 * 	2014-07-04
 * 	Created by Conduit Studio (conduitstudio.com)
 * 	Written for Steelcase (steelcase.com)
 * 	Written by Aaron Vanderzwan
 *
 * 	application.js
 * 	Version 2.0
 *
 *
 *  TABLE OF CONTENTS
 *
 *  @Initialize
 *  @Auto Instantiate
 *  ---------------
 *
 *
 */


/* JSHint */
/* globals console, confirm, Front, Modernizr, Cookies, ga, Mustache, alert, detectPointerEvents */
/* jshint loopfunc: true, curly: false, freeze: false, esnext: true */

// console.log(detectPointerEvents);

/* ---------------------------------- */

/* Caching */

var js_version = '2.0.33';
console.log('App Version: ' + Front.app_version);
console.log('JS Version: ' + js_version);
// throw new Error("Something went badly wrong!");
// Surface hub : 2436x1230
// Full screen: 2560x1440

/* ---------------------------------- */

/* Legacy Redirects */

// URL CHECK
var href = window.location.href;
if (
  // href === 'http://powerofplace.site/na-en/na-en/' || // <= testing on local
  // href.split('#')[0] === 'http://powerofplace.site/na-en/na-en/' || // <= testing on local
  href === 'http://powerofplace.steelcase.com/na-en' ||
  href === 'http://powerofplace.steelcase.com/na-en/' ||
  href.split('#')[0] === 'http://powerofplace.steelcase.com/na-en/'
) {

  // Redirect to home
  window.location = Front.site_url;

}



/* ---------------------------------- */

/* Detect Hover */

if( !(matchMedia('(hover: none)').matches) ) {
  document.body.classList.add('can-hover');
}




/* ---------------------------------- */

/* Native JS Widnow Load listener (breaking with jQuery + Service Worker) */

window.is_loaded = false;
window.addEventListener('load', function() {
  window.is_loaded = true;
}, false);




/* ---------------------------------- */

/* Service Worker */

// Register always loads the files that are in scspaces_get_my_download_files
var offline_available = false,
  sw_notify_already_setup = false;

function spaces_register_sw( offline_key ) { // <= offline_key has offline_pre already

  // Exceptions
  if (!Front.offline_enabled) return false;
  if (!Modernizr.fetch) return false;
  if (Front.is_entry_page) return false;
  if (window.location.href.replace(/\/$/, "") === Front.site_url.replace(/\/$/, "")) return false; //<= if the homepage

  // Do it
  if ('serviceWorker' in navigator) {
    var data_url = Front.api_url + '?action=scspaces_get_my_download_files';


    // Listen for download status updates
    if( ! sw_notify_already_setup ) {
      sw_notify_already_setup = true;

      navigator.serviceWorker.addEventListener('message', e => {
        // console.log('[Application] Received a message from service worker: ', e.data);
        // Note: e.data = {current: 31, percent: 0.97, total: 32};

        var customEvent;
        if (window.CustomEvent) {
          customEvent = new CustomEvent('scspaces-sw-dl-part', {detail: e.data});
        } else {
          customEvent = document.createEvent('scspaces-sw-dl-part');
          customEvent.initCustomEvent('scspaces-sw-dl-part', true, true, e.data);
        }
        window.dispatchEvent(customEvent);

      });

    }

    // console.log('[Application] SW URL: ' + '/service-worker.js?v=1&f=' + data_url + '&k=' + offline_key);
    navigator.serviceWorker
      .register('/service-worker.js?v=1&f=' + data_url + '&k=' + offline_key, {
        scope: '/'
      })
      // .then(function(registration) {
      //   console.warn('[Application] Service Worker Registered', registration);
      // })
      .catch(function(err) {
        console.warn("[Application] Service Worker Failed to Register", err);
      });

    return true;
  } else {
    console.warn( '[Application] The browser does not support service workers.' );
  }

  return false;
}
offline_available = spaces_register_sw( Front.offline_key ); // If we have an offline key
// console.log('iPad test:  Offline Available =', offline_available);



// alert('Version ' + js_version );
// alert(navigator.maxTouchPoints);
// alert('Version: ' + js_version + '.  Window size: ' + $(window).width() + ' x ' + $(window).height() + '. Touch Points: ' + navigator.maxTouchPoints );

/* ---------------------------------- */

/* Initialize */

jQuery(function($) {

  $.HTML = $('html');
  $.Body = $('body');
  $.Window = $(window);
  $.Document = $(document);

  // If is surface hub
  var is_surfacehub = false;
  if (/Edge/.test(navigator.userAgent) && navigator.maxTouchPoints === 100) {
    is_surfacehub = true;
    $.Body.addClass('is-surface-hub');
  }



  /*
   * Global VARS
   */
  $.Globals = {

    // Global Els
    present_bar_header: $('#present-bar-header'),
    search: $('#search'),
    saving_collection: $('#saving-collection'),

    // Defaults
    is_ipad_standalone: false,
    fxEasing: 'easeInOutQuint',
    fxSpeed: is_surfacehub ? 2250 : 500,
    navFXSpeed: 500,
    scrollSpeed: 750, // Onescroll speed is a touch slower
    is: {
      draganddrop: function() {
        var div = document.createElement('div');
        return ('draggable' in div) || ('ondragstart' in div && 'ondrop' in div);
      },
      ios: !!navigator.userAgent.match('iPhone OS') || !!navigator.userAgent.match('iPad'),
    },
    isEmail: function( email ) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },


    // Fetch
    fetch_options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache': 'no-cache'
      },
      credentials: 'same-origin'
    },


    doScript: function(url, callback) {

      // Adding the script tag to the head as suggested before
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;

      // Then bind the event to the callback function.
      // There are several events for cross browser compatibility.
      script.onreadystatechange = callback;
      script.onload = callback;

      // Fire the loading
      head.appendChild(script);

    },

    // URL Manipulation
    getUrlVars: function() {
      var vars = {},
        hash, i, url = document.URL;

      // Check if we have it stored already, if so just retrieve it.
      if (window.sessionStorage.getItem('url_vars-' + url) === null || window.sessionStorage.getItem('url_vars-' + url) === '') {

        // Dissect php vars
        if (url.indexOf('?') > 0) {
          var phpvars = url.slice(url.indexOf('?') + 1).split('&');

          for (i = 0; i < phpvars.length; i++) {
            hash = phpvars[i].split('=');

            vars[hash[0]] = hash[1];
          }
        }

        // Dissect hashes
        if (url.indexOf('#') > 0) {
          var hashes = url.slice(url.indexOf('#') + 1).split('&');

          for (i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');

            vars[hash[0]] = hash[1];
          }
        }

        // Store for easier retrieval later
        window.sessionStorage.setItem('url_vars-' + url, JSON.stringify(vars));

        // Return
        return vars;

      } else {
        return JSON.parse(window.sessionStorage.getItem('url_vars-' + url));
      }

    },
    scrollToSectionFromVars: function() {

      // We need to do some scrolling
      if ($('[data-controller="OneScroll"]').length > 0) {


        // Go to the zone
        var url_vars = $.Globals.getUrlVars(),
          $targetZone = url_vars.zone !== undefined ? $('section[data-targetzone="' + url_vars.zone + '"]') : $('section[data-targetzone]').first();


        // If we have a targetZone
        if ($targetZone.length > 0 && $targetZone !== 0 && $('section.active').data('targetzone') !== parseInt(url_vars.zone, 10)) {
          $targetZone.ScrollTo();
        } else {

          // Even though we aren't scrolling we want to make sure:
          // We are properly showing the carousel
          if ($targetZone.find('.flexslider').length > 0 && $targetZone.find('.flexslider').find('.slides > li').length > 1) {
            $.Globals.showCarousels();
          } else {
            $.Globals.hideCarousels();
          }

        }


        // Go to the slide if we found one
        var $slideshow = $targetZone.find('.flexslider');

        if ($slideshow.length > 0) {
          var $target_slide = url_vars.slide !== undefined ? $targetZone.find('.flexslider .slides > li[data-targetslide="' + url_vars.slide + '"]') : $targetZone.find('.flexslider .slides > li').first();
          if ($target_slide.length > 0 && parseInt($target_slide.data('targetslide'), 10) !== $targetZone.find('li.flex-active-slide').data('targetslide')) {
            $slideshow.flexslider($target_slide.index());
          }

          // Fade in the PPPs
          $.Globals.showPPP();

          // Show / hide products / insights button
          $.Globals.showHideSlideProductsInsightsButtons( $target_slide );

          // Update ppp content after animation is done to avoid height jump
          setTimeout(function() {
            $.Globals.updatePPPContent($target_slide);
          }, $.Globals.fxSpeed);

          // Show / hide scroll arrows
          $.Globals.showHideArrows();

          // Background images
          $.Globals.backgroundImages($target_slide.find('.background-images').first());


          // Update url_vars (may have been changed in one_scroll or flexslider)
          url_vars = $.Globals.getUrlVars();

          // Add flag to comments if this setting / collection has a comment
          if ($.Globals.is_online) {
            $.Globals.commentsNotification();
          }

          // Only do this if we don't run flexslider.before() (no url_vars yet)
          if (url_vars.slide === undefined || ($targetZone.is(':first-child') && $target_slide.is(':first-child'))) {

            // Update first slide title when no #zone or #slide in URL
            $.Globals.present_bar_header.empty().append($('.flex-active-slide').first().find('.top-title').first().clone());

            // Show / hide carousel
            if ($slideshow.find('.slides > li').length > 1) {
              $.Globals.showCarousels();
            }

          }

        }

      } else {

        // This is a static page
        // Update the title
        if ($('.static-top-title').length > 0) {
          // Add static page titles if it exists
          $.Globals.present_bar_header.empty().append($('.static-top-title').first().clone());
        }

        // Show / hide scroll arrows
        $.Globals.showHideArrows();

      }


    },

    // Scroll arrows
    prevIcon: $('.icon-prev'),
    nextIcon: $('.icon-next'),
    showHideArrows: function() {

      var url_vars = $.Globals.getUrlVars(),
        $zones = $('section[data-targetzone]'),
        $targetZone;


      // Only run if we have more than 1 zone
      if ($zones.length > 1) {

        $targetZone = $('section[data-targetzone="' + url_vars.zone + '"]');
        if ($targetZone.length === 0) {
          $targetZone = $zones.first();
        }

        // NOTE: Same as below
        // Always,
        // Show / hide prev / next if we are at the end
        if ($targetZone.is(':first-child')) {
          $.Globals.prevIcon.hide();
          $.Globals.nextIcon.show();
        } else if ($targetZone.is(':last-child')) {
          $.Globals.prevIcon.show();
          $.Globals.nextIcon.hide();
        } else {
          $.Globals.prevIcon.show();
          $.Globals.nextIcon.show();
        }
      } else {
        $.Globals.prevIcon.hide();
        $.Globals.nextIcon.hide();
      }

    },

    // Product / Insight Buttons
    showHideSlideProductsInsightsButtons: function( $target_slide ) {
      if ($target_slide.find('.views .products').length > 0) {
        $.HTML.addClass('slide-products');
      } else {
        $.HTML.removeClass('slide-products');
      }
      if ($target_slide.find('.views .insights').length > 0) {
        $.HTML.addClass('slide-insights');
      } else {
        $.HTML.removeClass('slide-insights');
      }
    },

    // PPP
    closePPP: function() {

      $.Globals.pppContent.removeClass('opened');

    },
    isSliding: false, // If slideshow is sliding, don't open PPP
    ppp: $('#ppp'),
    pppContent: $('#ppp-content'),
    showPPP: function() {
      $.Globals.ppp.addClass('visible');
    },
    updatePPPContent: function($toSlide) {

      var $slidePPPContent = $toSlide.find('.ppp-content');
      if ($slidePPPContent.length > 0) {

        // Setup new element from current setting
        var $newEl = $slidePPPContent.clone();
        $.Globals.pppContent.empty().append($newEl).append('<span class="tag"></span>');

        // Change tag color on maps
        if ($toSlide[0].id === 'floorplan') {
          $.Globals.pppContent.find('.tag').addClass('map-tag');
        }

      }

      // Hide collections in PPP
      $.Globals.pppContent.removeClass('collections-open');

    },

    // Comments in Presentation
    comments_trigger: $('#comments-trigger'),
    showComments: function() {
      $.Body.addClass('slide-has-comments');
      $.Globals.comments_trigger.addClass('visible');
    },
    commentsNotification: function() {

      // If on a single collection
      if (
        $.HTML.hasClass('user-collection') &&
        $('[data-controller="OneScroll"]').length > 0 &&
        $.Globals.is_online
      ) {
        var collection_id = $('[data-controller="OneScroll"]').data('collectionid'),
          slide_id = $('.flex-active-slide').data('targetslide'),
          the_collection_slide = $.Globals.getCollectionSlideById(collection_id, slide_id);

        if (the_collection_slide.comments.length > 0) {
          $.Globals.comments_trigger.addClass('has-flag');
        } else {
          $.Globals.comments_trigger.removeClass('has-flag');
        }

        // console.log('update comments popup-trigger,' {cid: collection_id, sid: slide_id });
        $.Globals.comments_trigger.attr('data-cid', collection_id ).attr('data-sid', slide_id);

        // Show comments
        $.Globals.showComments();
      }

    },

    // Ajax
    // Note: Everytime we make a change to a collection via AJAX we have to save the new collections locally (reduce lag)
    _ajax_save_collections_and_callback: function(response, callback) {

      // Save the response
      if (response.fresh_collections !== undefined) {
        $.Globals.saveCollections(response.fresh_collections);
      }else if (response.data !== undefined && response.data.fresh_collections !== undefined) { // <= if using wp_send_json_success()
        $.Globals.saveCollections(response.data.fresh_collections);
      }

      // If we have a callback, run it
      if (callback !== undefined) {
        callback(response);
      }

    },
    ajax: function(action, options, callback) {

      // add prefix
      if( ! action.includes( 'scspaces_' ) ) {
        action = 'scspaces_' + action;
      }

      // Unpack vars into string
      var the_vars = '';
      if (options !== undefined && typeof(options) !== "function") {

        $.each(options, function(key, val) {
          the_vars += '&' + key + '=' + encodeURIComponent(val);
        });

      } else if (options !== undefined && typeof(options) === "function") {
        callback = options;
      }

      $.ajax(Front.api_url + "?action=" + action + the_vars + "&type=json", {
        dataType: 'json',
        success: function(data) {
          $.Globals._ajax_save_collections_and_callback(data, callback); // <= save our collections (if fresh_collections exists), then run our callback
        },
        error: function() {
          if (callback !== undefined) {
            callback(false);
          }
        },
        cache: false,
        timeout: 10000 // 10 second timeout
      });
    },
    ajax_post: function( action, options, callback ) {

      // add prefix
      if( ! action.includes( 'scspaces_' ) ) {
        action = 'scspaces_' + action;
      }

      // Potential issue if note is too long.  may have to use POST request
      $.ajax(Front.api_url + "?action=" + action + "&type=json", {
        data: options,
        dataType: 'json',
        type: 'post',
        success: function(data) {
          $.Globals._ajax_save_collections_and_callback(data, callback);
        },
        error: function() {
          if (callback !== undefined) {
            callback(false);
          }
        },
        cache: false,
        timeout: 10000 // 10 second timeout
      });

    },

    addRemoveSlideFromCollection: function(collection_id, slide_id) {

      // Vars
      var the_collection = $.Globals.getCollectionById(collection_id),
        slide_index = the_collection.slides ? the_collection.slides.indexOfByProperty('slide', slide_id) : -1,
        action;

      // It doesn't exist, so we need to add it
      if (slide_index === -1) {

        $.Globals.ajax( 'collection__add_slide', { cid: collection_id, sid: slide_id }, function( success ) {
          if( success === false ) {
            $.Body.trigger('ajax_add_slide_to_collection_error');
          } else {
            $.Body.trigger('ajax_add_slide_to_collection_success');
          }
        });

        action = 'added';

      } else {

        // Remove from collection
        $.Globals.ajax( 'collection__remove_slide', { cid: collection_id, sid: slide_id } );

        action = 'removed';

      }

      // Return the action
      return action;

    },
    getCollections: function(type) {

      // Returns
      if (window.localStorage.getItem('collections') === null || window.localStorage.getItem('collections') === '') {

        return [];

      } else if (type === undefined) {

        // return jQuery.parseJSON( window.localStorage.getItem('collections_' + Front.current_language) );
        return jQuery.parseJSON(window.localStorage.getItem('collections'));

      } else {

        var collections = jQuery.parseJSON(window.localStorage.getItem('collections'));
        return $.grep(collections, function(e) {
          return e.type === type;
        });

      }

    },
    getCollectionById: function(collection_id) {
      // Make sure it's recent
      // TODO: Eventually maybe cache this in some way
      var collections = $.Globals.getCollections();
      if (collections.length === 0) {
        return false;
      } else {
        return $.grep(collections, function(e) {
          return parseInt(e.id, 10) === parseInt(collection_id, 10);
        })[0];
      }
    },
    getCollectionSlideById: function(collection_id, slide_id) {

      // Get this collection
      var the_collection = $.Globals.getCollectionById(collection_id);
      if (the_collection.length === 0 || the_collection.slides.length === 0) {
        return false;
      } else {
        return $.grep(the_collection.slides, function(e) {
          return parseInt(e.slide, 10) === parseInt(slide_id, 10);
        })[0];
      }

    },
    saveCollections: function(collections) {

      // Save
      // window.localStorage.setItem('collections_' + Front.current_language, JSON.stringify( collections ) );
      window.localStorage.setItem('collections', JSON.stringify(collections));

    },

    // Collection in the Personal Menu
    myCollectionsMenuItem: $('#menu-personal .personal-collections'),
    menuCollectionVarName: 'menu_collection_' + Front.current_language,
    getMenuCollectionItem: function() {

      var collections = $.Globals.getCollections();
      if (collections.length === 0) {
        return false;
      } else {
        return $.grep(collections, function(e) {
          return e.type === 'menu_collection_id';
        })[0];
      }

    },

    // Carousels
    carousels: $('#carousels'),
    carouselTrigger: $('#carousels .carousel-trigger').first(),
    closeCarouselNav: function() {
      if ($.Globals.carousels.hasClass('carousels-activated')) {
        $.Globals.carouselTrigger.trigger($.Globals.clickEvent + '.carouseltrigger');
      }
    },
    flashCarousels: function() {
      $.Globals.carouselTrigger.trigger($.Globals.clickEvent);

      setTimeout(function() {
        $.Globals.closeCarouselNav();
      }, 2000);
    },
    hideCarousels: function() {
      $.Globals.carousels.removeClass('show');
    },
    showCarousels: function() {
      $.Globals.carousels.addClass('show');
    },

    // Slides
    _bgImages_interval: 0,
    _backgroundImages: function($backgroundImgs) {

      var $bgChildren = $backgroundImgs.children(),
        i = 1;
      clearInterval($.Globals._bgImages_interval);
      if ($bgChildren.length > 1) {

        var this_delay = 2000,
          this_fx_speed = 750;
        if (is_surfacehub) {
          this_delay = 4000;
          this_fx_speed = 1750;
        }

        $.Globals._bgImages_interval = setTimeout(function() {

          // Set our currently active image
          var $currActive = $bgChildren.first();

          if ($currActive.index() === $bgChildren.length - 1) {
            clearInterval($.Globals._bgImages_interval);
            return;
          } else {

            // Different timing for surface hubs
            $currActive.next().css('z-index', i).addClass('active').stop().fadeTo(this_fx_speed, 1);
            $currActive.removeClass('active').css('z-index', i).stop().fadeTo(this_fx_speed, 0);
            i++;
          }

        }, this_delay);


      }

    },
    backgroundImages: function($backgroundImgs) {

      if ($.Body.hasClass('loaded')) {
        $.Globals._backgroundImages($backgroundImgs);
      } else {
        var loaded_yet = setInterval(function() {

          if ($.Body.hasClass('loaded')) {
            clearInterval(loaded_yet);
            $.Globals._backgroundImages($backgroundImgs);
          }

        }, 100);
      }

    },


    // V4+ overlays
    closePopups: function() {
      // Stop listening for global close
      $.Document.off($.Globals.clickEvent + '.global-popup-close');
      $('.popup-trigger.active').removeClass('active'); // <= slide action triggers
      $('.popup.on').removeClass('on'); // <= product / insights
      $('body > .popup').remove();
    },
    closeOverlay: function() {
      $.Body.removeClass('overlay-white-on');
      $.Document.off($.Globals.clickEvent + '.global-overlay-close');

      setTimeout(function() {

        $('#overlay-white').remove();

      }, $.Globals.fxSpeed);
    },
    listenForGlobalClosePopup: function( callback ) {

      $.Document.off($.Globals.clickEvent + '.global-popup-close').on($.Globals.clickEvent + '.global-popup-close', function(e) { // <= global listen for close popup

        // Exceptions
        if ($('body > .popup').length === 0) return;
        if ($(e.target).closest('#slide__add-to-collection-box').length > 0) return;
        if ($(e.target).closest('#slide__comments-box').length > 0) return;
        if ($(e.target).hasClass('popup-trigger')) return;

        // Run callback
        if( callback ) callback();

        // Close it
        $.Globals.closePopups();

      });

      // Close if resize window
      $.Window.off('resize.global-popup-close').on('resize.global-popup-close', $.Globals.closePopups );

    },
    listenForGlobalCloseOverlay: function( callback ) {

      // Also on default close overlay listeners
      $.Document.on( $.Globals.clickEvent + '.global-overlay-close-default', '.close-overlay', function(e) {
        e.preventDefault();

        // Callback
        if(callback) callback();

        // Clean listener
        $.Document.off( $.Globals.clickEvent + '.global-overlay-close-default');
      });


      // Add document close overlay listener
      $.Document.off($.Globals.clickEvent + '.global-overlay-close').on($.Globals.clickEvent + '.global-overlay-close', function(e) { // <= global listen for close overlay

        // Exceptions
        if ($('body > #overlay-white').length === 0) return;
        if ($(e.target).closest('.overlay-content').length > 0) return;

        // If clicking on a popup while an overlay is open
        if ($(e.target).closest('.popup').length > 0) return;

        // Run callback
        if( callback ) callback();

        // Close it
        $.Globals.closeOverlay();

      });

    },
    overlayNotify: function($el, saving_message, complete_message) {

      // 1) Show saving message
      // 2) Setup 'overlay-notify-success' listener
      // 3) Trigger 'overlay-notify-complete' event when done

      // Vars
      var $overlay = $('#overlay-white'),
        $confirmation = $('#action-confirmation');

      // Change message to saving and animate it in
      $confirmation.find('.message').empty().html(saving_message + '...');
      $overlay.addClass('show-notification');

      // Listeners
      $el.off('overlay-notify-success').on('overlay-notify-success', function() {

        setTimeout(function() {

          // Hide notification
          $overlay.removeClass('show-notification');

          // After they are hidden
          setTimeout(function() {

            // change message to complete and slide it back in
            $confirmation.find('.message').empty().html(complete_message);
            $overlay.addClass('show-notification');

            // Wait for a spec length of time
            setTimeout(function() {

              $overlay.removeClass('show-notification');

              // When done
              setTimeout(function() {

                // Trigger complete
                $el.trigger('overlay-notify-complete');

              }, $.Globals.fxSpeed);

            }, 1250);

          }, $.Globals.fxSpeed);

        }, 1000);


      });


    },


    // Global clicks
    clickEvent: ("standalone" in window.navigator) && window.navigator.standalone ? 'touchend' : 'click',
    disable_keyboard: false,
    transitionEnd: '',
    transitionEndEventName: function() {
      var i,
        el = document.createElement('div'),
        transitions = {
          'transition': 'transitionend',
          'OTransition': 'otransitionend', // oTransitionEnd in very old Opera
          'MozTransition': 'transitionend',
          'WebkitTransition': 'webkitTransitionEnd'
        };

      for (i in transitions) {
        if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
          return transitions[i];
        }
      }

      //TODO: throw 'TransitionEnd event is not supported in this browser';
    },

    // User ID
    user_cookie: 'scspaces-uid-11',
    setupUserID: function() {

      // User is logged in so set userID
      if (Cookies.get( $.Globals.user_cookie ) !== undefined) { // <= set this everytime the page loads to overwrite an undefined value

        window.localStorage.setItem('user_id', Cookies.get( $.Globals.user_cookie ));

      } else if (window.localStorage.getItem('user_id') === undefined || window.localStorage.getItem('user_id') === null) {

        var random_user_id = Math.floor(Date.now() / 1000);
        window.localStorage.setItem('user_id', 'noscsuserid-' + random_user_id);

      } else {
        window.localStorage.removeItem('user_id');
      }

    },
    decode_user_id: function(encoded_uid) {
      return atob(encoded_uid.substr(10));
    },
    getUserID: function() {
      return $.Globals.decode_user_id(window.localStorage.getItem('user_id'));
    },


    // Analytics
    test_analytics: false,
    track_event: function(eventAction) {

      var tmp_interval = 0;
      tmp_interval = setInterval(function() {

        // Clear it
        clearInterval(tmp_interval);

        var ga_object = {
          'eventCategory': Front.current_language,
          'eventAction': eventAction,
          'eventLabel': Front.app_version,
        };

        // If tracking is turned on, online and have google analytics
        if (Front.app_event_tracking && typeof(ga) === "function") { // <= Make sure google analytics is installed

          // console.log('Track_event(): sending...');
          // console.log( ga_object );

          // Send this event
          ga('send', 'event', ga_object);

        } else if ($.Globals.test_analytics) {

          // Submit to google testing
          console.log('Track_event(): GA Object...');
          console.log(ga_object);

        }

      }, 20);

    },
    track_page: function() {

      // If tracking is turned on, online and have google analytics
      var tmp_interval = 0;
      tmp_interval = setInterval(function() {

        // Clear it
        clearInterval(tmp_interval);

        // Set name
        var page = location.pathname + window.location.hash,
          custom_user = $.Globals.getUserID();

        // If tracking is turned on, online and have google analytics
        if (Front.app_event_tracking && typeof(ga) === "function") { // <= Make sure google analytics is installed

          // Sets the page value on the tracker.
          ga('set', 'page', page);

          // Sending the pageview no longer requires passing the page
          // value since it's now stored on the tracker object.
          ga('set', 'dimension1', custom_user);
          ga('set', 'dimension2', 'online');
          ga('send', 'pageview');

        } else if ($.Globals.test_analytics) {

          // Submit to google testing
          console.log({
            d: 'track_page()',
            page: page,
            dimension1: custom_user,
            dimension2: 'online'
          });

        }

      }, 20);

    },

    is_homepage: function() {

      return $.Body.hasClass('home');

    },
    is_online: false,
    connection_checked: false,
    on_connected: function(callback) {

      // First, run ajax to check to see if we have server access
      if ($.Globals.connection_checked) {
        if (callback) callback(true);
        return $.Globals.is_online;
      }

      // Using XHR because fetch() may not be supported in older browser and this is important
      $.get(Front.api_url + "?action=spaces_check_connection")
        .done(function() {

          $.Globals.is_online = true;
          $.Globals.connection_checked = true;

          if (callback) callback(true);

        }).fail(function() {

          $.Globals.is_online = false;
          $.Globals.connection_checked = true;

          if (callback) callback(false);

        });

    },

    redirect_if_offline: function() {

      $.Globals.on_connected(function(is_online) {

        // Exceptions
        if (is_online) return;


        // Add class to body
        $.Body.addClass('is-offline');

        // Skip
        if ($.Body.hasClass('page-template-template-system-c-downloaded')) return;
        if ($.Body.hasClass('downloaded-collection')) return;

        // TODO: Fix this from redirecting incorrectly
        // Redirect to Downloaded page
        window.location = Front.downloaded_collections_url;
        return false;

      });

    },

    list_cache: function() {
      if (offline_available) {

        // console.log('\n[ListCache] Start');
        window.caches.keys().then(
          cache_keys => {
            // console.log('[ListCache] CacheKeys', cache_keys);
            return cache_keys[0];
          }
        ).then(
          cache_name => {

            // console.log('[ListCache] CacheName', cache_name);
            window.caches.open(cache_name).then(
              cache => {

                cache.matchAll().then(files => {

                  console.log(files.map((item) => item.url));
                });

              }
            );
            // console.log('[ListCache] End\n');
          }
        );

        // const caches = await self.caches.keys();
        // const cache = await self.caches.open( caches[0] );

        // return cache;
        // let files = await self.cache.matchAll();
        // console.table( files );

      } else {
        return "Offline is not available ";
      }
    }
  };


  // Add deprecated methods
  const deprecated_global_methods = [
    { method: 'ajax_duplicate_collection', version: '4.1' },
    { method: 'ajax_get_my_notifications', version: '4.1' },
    { method: 'ajax_share_collection', version: '4.1' },
    { method: 'ajax_update_note', version: '4.1' },
    { method: 'ajax_add_slide_to_collection', version: '4.1' },
    { method: 'ajax_remove_slide_from_collection', version: '4.1' },
    { method: 'ajax_create_new_collection', version: '4.1' },
    { method: 'ajax_get_slides', version: '4.1' },
    { method: 'ajax_import_old_collections', version: '4.1' },
    { method: 'ajax_move_slide_in_collection', version: '4.1' },
    { method: 'ajax_remove_collection', version: '4.1' },
    { method: 'ajax_set_menu_collection_item', version: '4.1' },
    { method: 'ajax_update_collection_title', version: '4.1' },
  ];
  $.each( deprecated_global_methods, function( i, obj ) {
    $.Globals[ obj.method ] = function() {
      console.error( 'Error: ' + obj.method + '() was deprecated in v' + obj.version + '. ');
    };
  });


  // const cache_list = $.Globals.list_cache();
  // $.Globals.list_cache();
  // console.log( $.Globals.list_cache() );


  // Check connection for a possible redirect
  $.Globals.redirect_if_offline();

  // If online, but offline is not available
  if ( ! offline_available ) {
    const offline_checks = {
      '! Front.offline_enabled': (!Front.offline_enabled),
      '! Modernizr.fetch': (!Modernizr.fetch),
      ' Front.is_entry_page ': Front.is_entry_page,
      'is homepage (redirects to /new/)': (window.location.href.replace(/\/$/, "") === Front.site_url.replace(/\/$/, "")),
      "'serviceWorker' in navigator": ('serviceWorker' in navigator)
    };
    console.log('Offline is Not Available', offline_checks);

    $.Body.addClass('no-offline-supported');
    $('[data-controller="Collection__Download"]').hide();
  }

  // Redirect to new (if this is the Front.site_url)
  // NOTE: this allows us to redirect to Front.downloaded_collections_url if not online in $.Globals.if_offline() and bypass WPE homepage cache
  $.Globals.on_connected( function() {

    // if ( $.Body.hasClass('home') && $.Globals.is_online ) {
    if ( ( $.Body.hasClass('home') || $.Body.hasClass('page-template-template-system-login') ) && $.Globals.is_online ) {

      if( Cookies.get( $.Globals.user_cookie ) !== undefined && Cookies.get( $.Globals.user_cookie ) !== false ) {

        // Redirect to new (Auth() handles bad users)
        setTimeout( () =>  {
          window.location = Front.new_url;
        }, 1000 );

      } else {

        // Don't redirect to entry page if we are on entry page
        if( ! $.Body.hasClass('page-template-template-system-login') ) {
          setTimeout( () =>  {
            window.location = Front.entry_url;
          }, 1000 );
        }

      }
    }
  });


  // Hide for public
  if (Front.is_public) {
    $('.hide-for-public').remove();
  }



  /*
   * Onready Setups
   */
  // Create or pull user ID from Cookie into local storage
  $.Globals.setupUserID();

  // Convert obfuscated vars for easier readability
  Front.search_terms = Front.st.length > 0 ? JSON.parse(window.atob(Front.st.slice(0, 29) + Front.st.slice(30))) : false;

  // Get and save our transition end event name per our device
  $.Globals.transitionEnd = $.Globals.transitionEndEventName();




  /*
   * Notices
   */
  // Setup analytics stuff
  if (Front.app_event_tracking === undefined || !Front.app_event_tracking) {
    console.log("Notice: Event Tracking turned off.");
  }


  /*
   * Login Check and iPad
   */
  if (
    ("standalone" in window.navigator) &&
    window.navigator.standalone
  ) {

    // Save for later
    $.Globals.is_ipad_standalone = true;

    // Hide our login / logout
    $('.login_out').hide();

  }




  /*
   * iPad Standalone actions
   */
  if ($.Globals.is_ipad_standalone) {

    // Custom management of links
    $.Body.css('background-color', '#000');

    // This captures only redirection which happens on click event
    $.Document.on('click', 'a, area', function(e) {

      var $this = $(this),
        href = $this.attr('href');

      // The categories: nothing, reload, false, window.location, true
      if (typeof href === 'undefined' ||
        href.length === 0 ||
        $this.hasClass('has-children') ||
        $this.hasClass('primary-menu-trigger') ||
        $this.hasClass('personal-menu-trigger') ||
        $this.hasClass('personal-menu-trigger') ||
        $this.hasClass('empty-favorites') ||
        $this.hasClass('favorited-item') ||
        $this.attr('id') === 'ppp-trigger' ||
        $this.attr('id') === 'favorited-email' ||
        $this.attr('id') === 'favorited-print' ||
        $this.attr('id') === 'favorited-clear') { // if open or close nav

        // Nothing
        e.preventDefault();

      } else if ($this.attr('id') === 'update') {

        // Reload
        window.location.reload();

      } else if ($this.attr('target') === '_blank') {

        // Open these in safari browser
        return true;

      } else {

        // Don't open safari, but redirect to new page
        e.preventDefault();
        window.location = href;

      }

    });

  }



  // If user is logged in
  if (Modernizr.localstorage && window.localStorage.getItem('user_id')) {

      /*
       * Collections Setup
       */
      $.Globals.ajax('get_my_collections', function(data) {

        // Populate collections locally from ajax
        $.Globals.saveCollections(data);

        // If in present mode, load other things
        if (Front.mode === 'present') {

          // Activate menu items
          var $trigger,
            activate_menu_id = $('.activate-menu').data('activatemenuid');

          if (activate_menu_id !== undefined) {
            $trigger = $('.slideout-menu li[data-id="' + activate_menu_id + '"] a').not('.back');

            // Click it
            $trigger.trigger($.Globals.clickEvent);

            // Fade out original (in case it isn't in the same hierarchy)
            if (activate_menu_id !== 0 && $trigger.length > 0 && $('#menu-' + $trigger.data('menu')).length > 0) {
              $trigger.closest('.slideout-menu').children('ul:first-child').hide();
            }
          }

          // Automatically scroll to section if it's included in the url
          $.Globals.scrollToSectionFromVars(document.URL);

        }

      });

      /*
       * Get notifications ( ASYNC )
       */
      $.Globals.ajax( 'get_my_notifications', {}, function( response ) {

        if( response.success && response.data.length > 0 ) {

          // Look for collection_shared.
          let has_recent = false;
          $.each(response.data, function(i, notification) {
            if( notification.type === 'collection_shared' ) {
              has_recent = true;
              return false;
            }
          });

          // What to do with it.
          if( has_recent ) {

            // Handle collection shared notifications
            $.Body.addClass('has-recent-collection');
            $('#menu-personal > .shared-with-me a, .menu-extras .shared-with-me a').append('<span class="green-flag"></span>');

          }

        } else {
          console.warn( response );
        }

      });

    // });

  }




  /*
   * Document / dynamic listeners
   */
  $.Document
    .on($.Globals.clickEvent, '.inactive', function(e) {

      e.preventDefault();

    })
    .on($.Globals.clickEvent, '.ppp-choose-collections', function(e) {
      e.preventDefault();

      var $pppcontent = $('#ppp-content'),
        $collections = $pppcontent.find('.ppp-collections'),
        template = $('#ppp-collections-mst').html(),
        collections = $.Globals.getCollections(),
        slide_id = $('section.active .flex-active-slide').data('targetslide'),
        ppp_collections = [];


      // Find out if this setting is in our collection
      if (collections) {
        $.each(collections, function(j, collection) {

          if (collection.type === 'my_collection' || collection.type === 'sent_collection') {

            ppp_collections.push(collection);

            if (collection.slides) {
              // Also loop settings to add flag
              $.each(collection.slides, function(k, slide_holder) {
                // console.log(slide_holder.slide + ' === ' + slide_id);
                // Check settings
                collections[j].has_slide = false;

                if (slide_holder.slide === slide_id) {
                  collections[j].has_slide = true;
                  return false;
                }

              });
            }
          }

        });
      }

      ppp_collections = ppp_collections.reverse();

      // Add collections to dom
      Mustache.parse(template);
      var output = Mustache.render(template, ppp_collections);
      $collections.html(output);

      // Animate collections in
      $('#ppp-content').addClass('collections-open');

    })
    .on($.Globals.clickEvent, '.ppp-collections-back', function(e) {
      e.preventDefault();

      // Animate collections in
      $('#ppp-content').removeClass('collections-open');

    })
    .on($.Globals.clickEvent, '.ppp-add-to-new-collection', function(e) {
      e.preventDefault();


      var $input = $('#new-collection-title'),
        $form = $('#name-new-collection'),
        slide_id = $('section.active .flex-active-slide').length > 0 ? parseInt($('section.active .flex-active-slide').data('targetslide')) : undefined;

      // Close it if it's already opened / reset it
      if (!$form.hasClass('off')) {
        $input.blur().val('');
        $form.addClass('off');

        return;
      }

      //
      $.Globals.disable_keyboard = true;

      // Focus on it
      $input.focus();

      // Slide form out and listen for submit
      $form.removeClass('off').off('submit.add-to-new-collection').on('submit.add-to-new-collection', function(e) {
        e.preventDefault();

        $.Globals.ajax('scspaces_create_new_collection', {
          ctitle: $input.val(),
          request_from: 'popup'
        }, function(data) {

          // Add slide to this collection
          $.Globals.addRemoveSlideFromCollection(data.new_collection.id, slide_id);

          // Add new collection to list
          $form.after('<a href="#" class="ppp-add-collection has-slide off" data-collectionid="' + data.new_collection.id + '">' + data.new_collection.title + '</a>');

          // Animate them in
          setTimeout(function() {
            $form.addClass('off');
            $input.blur().val('');
            $('.ppp-add-collection.off').removeClass('off');
          }, 10);
          $.Globals.disable_keyboard = false;

        });

      });

    })
    .on($.Globals.clickEvent, '.ppp-add-collection', function(e) {
      e.preventDefault();

      var $this = $(this),
        collection_id = $this.data('collectionid'),
        slide_id = $('section.active .flex-active-slide').data('targetslide');

      if (slide_id !== undefined) {

        var action = $.Globals.addRemoveSlideFromCollection(collection_id, slide_id);
        if (action === 'added') {

          // Track in Google
          $.Globals.track_event('Setting Added to Collection');

          // Mark it with blue flag
          $this.addClass('has-slide');

        } else {

          // Track in Google
          $.Globals.track_event('Setting Removed from Collection');

          $this.removeClass('has-slide');
        }

      }

    })
    .on($.Globals.clickEvent, '.force-download', function() {

      var $this = $(this),
        now = new Date(),
        nowUTC = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds()),
        t = btoa(nowUTC.timestamp()),
        rand = '7',
        position = 7,
        original_href = $this.attr('href');

      // Add rand
      t = [t.slice(0, position), rand, t.slice(position)].join('');

      // Update href before submission
      $this.attr('href', original_href + '&t=' + t);

      // Reset after submission
      setTimeout(function() {
        $this.attr('href', original_href);
      }, 1000);

    })
    .on($.Globals.clickEvent, '.close-overlay', function(e) {

      // Listen for close
      e.preventDefault();

      $.Globals.closeOverlay();

    })


    // Keyboard listeners
    .on('keyup', function(e) {

      // Cases where we need our keyboard for typing
      if (
        e.which !== 27 && ( // <= esc superscedes these exceptions
          $.Globals.disable_keyboard === true ||
          $(e.target).is("input") ||
          $(e.target).is("textarea") ||
          $.Body.hasClass('overlay-enter-email-on') ||
          $.Globals.search.hasClass('form-on') // <= typing in search field
        )) {
        return;
      }

      // console.log(e.which);
      var $currSlider;
      switch (e.which) {
        case 37: // left
          console.log('heard prev');

          $currSlider = $('section.active').find('.flexslider');
          if ($currSlider.length > 0 && !$currSlider.find('.flex-active-slide').is(':first-child')) {
            // console.log('trigger prev');
            $currSlider.flexslider('prev');
          } else if( $('#overlay-white a.prev').length > 0 ) {
            $('#overlay-white a.prev').trigger($.Globals.clickEvent);
          }
          break;

        case 39: // right
          console.log('heard next');

          $currSlider = $('section.active').find('.flexslider');
          if ($currSlider.length > 0 && !$currSlider.find('.flex-active-slide').is(':last-child')) {
            // console.log('trigger next');
            $currSlider.flexslider('next');
          } else if( $('#overlay-white a.next').length > 0 ) {
            $('#overlay-white a.next').trigger($.Globals.clickEvent);
          }
          break;

        case 27: // 'esc'

          // Blur inputs and textarea fields
          $('input, textarea').trigger('blur');

          // Close PPP or views
          $('.oc-content.opened').siblings('.oc-trigger').first().trigger($.Globals.clickEvent);

          // Close carousel
          $('.carousels-activated').removeClass('carousels-activated');

          // Close overlay
          $.Globals.closeOverlay();

          // Close popups
          $.Globals.closePopups();

          break;

        case 67: // "c"
          if ($('#carousels').hasClass('show')) {
            $('#carousels > .carousel-trigger').trigger($.Globals.clickEvent);
          }
          break;

        case 86: // "v"
          $('#views-trigger').trigger($.Globals.clickEvent);
          break;

        case 78: // "n"
          $('#comments-trigger').trigger($.Globals.clickEvent);
          break;

        case 80: // "p"
          $('#ppp-trigger').trigger($.Globals.clickEvent);
          break;

        default:
          return; // exit this handler for other keys
      }
    });




  /*
   * Overlay Help
   */
  if (window.sessionStorage.getItem('scspaces_help') === null && window.localStorage.getItem('scspaces_overlay_help_on') !== 'false' && !Front.is_entry_page) {

    // Show it
    $.Body.addClass('overlay-help-on');

    // Stop from showing next time
    window.sessionStorage.setItem('scspaces_help', true);

  }
  $('#overlay-help').on($.Globals.clickEvent + '.close-overlay-help', function(e) {
    e.preventDefault();
    $.Body.removeClass('overlay-help-on');
  });



  /*
   * Global Actions
   */
  $('[data-action="CloseWindow"]').on($.Globals.clickEvent, function() {
    window.close();
  });

  // General instatiations
  $('html').removeClass('no-js');


  /*
   * Track actions that are on load
   */
  if ($.Body.hasClass('.single-collection') && $('[data-controller="Flexslider"]').length > 0) {

    // Viewing a collection
    $.Globals.track_event('Collection Viewed');

  } else if ($.Body.hasClass('.single-collection') && $('[data-controller="Flexslider"]').length === 0) {

    // Editing a collection
    $.Globals.track_event('Collection Edited');

  }

  // V4, moved to here to run every load
  $('[data-controller]').Instantiate();






  /*
   * Window listeners
   */
  var win_load_ran = false;
  $.Window
    .on("hashchange.app", function() {

      // This runs each time the hash is changed
      $.Globals.scrollToSectionFromVars(document.URL);

      // Keep track of all page navigations
      $.Globals.track_page();
      $.Globals.track_event('Navigation');

    })
    .on('load.app', function() {

      if (!win_load_ran) {

        win_load_ran = true;

        $.Window.trigger('resize.av');
        setTimeout(function() {

          if( $.Globals.is_homepage() ) return; // <= Never show the homepage

          // Fade in the content
          $('header, nav, .main, section, footer, form').css('opacity', 1);

          // Hide loader screen and mini loading graphic in right nav
          $('#loader, #animating-gif').fadeOut();
          $('#app-version').html(Front.app_version);

          // Show carousel trigger if this active section has a slideshow
          if ($('section.active .flexslider').length > 0) {
            $.Globals.flashCarousels();
          }

          // Trigger loaded
          $.Body.addClass('loaded');

        }, 100);


      }

    });

  // Native JS window load listener has already run, so just trigger it
  if (window.is_loaded) {
    $.Window.trigger('load');
  }

});



/* ---------------------------------- */

/* Auto Instantiate
	NOTE: This function loads a 'plugin' for each data-controller */

(function($) {
  'use strict';
  $.fn.Instantiate = function(settings) {
    var config = {};
    if (settings) {
      $.extend(config, settings);
    }
    this.each(function() {
      var $self = $(this),
        $controller = $self.data('controller');

      if ($self[$controller]) {
        $self[$controller]();
        $self.addClass('instantiated');
      }
    });
  };
}(jQuery));







/* ---------------------------------- */

/* Controllers (4.0) */

// @codekit-append "_controllers.js"



/* ---------------------------------- */

/* CarouselNav */

(function($) {
  'use strict';
  $.fn.CarouselNav = function() {
    this.each(function() {

      var $carousel_holder = $(this),
        $carousel_flex = $carousel_holder.find('.flexslider');

      // Placement
      $carousel_flex.on('carousel-reposition', function() {


      });

      // Initial run triggered on flexslider.start()
      $carousel_flex.on('carousel-loaded', function() {
        $.Window.trigger('resize.carousel-position');
      });

    });
    return this;
  };
}(jQuery));



/* ---------------------------------- */

/* CarouselTrigger */

(function($) {
  'use strict';
  $.fn.CarouselTrigger = function() {
    this.each(function() {

      var $self = $(this),
        $carousels = $.Globals.carousels;

      $self.on($.Globals.clickEvent + '.carouseltrigger', function(e) {
        e.preventDefault();

        var zone_id = $('section.active').data('targetzone'),
          $current_carousel = $carousels.find('.carousel-holder.carousel-' + zone_id);

        // Account for intro screen slideshow
        if (zone_id === undefined && $('section.active').data('targetintroscreen') !== undefined) {
          zone_id = 0;
          $current_carousel = $carousels.find('.carousel-holder.carousel-' + zone_id);
        }

        // Activate / deactivate
        if ($carousels.hasClass('carousels-activated')) {
          $carousels.removeClass('carousels-activated');
          $carousels.find('.activated').removeClass('activated');
        } else {
          $carousels.addClass('carousels-activated');
          $current_carousel.addClass('activated');
        }
      });

    });
    return this;
  };
}(jQuery));




/* ---------------------------------- */

/* Flexslider */

(function($) {
  'use strict';
  $.fn.Flexslider = function() {
    this.each(function() {

      var $self = $(this),
        $ppp = $('#ppp'),
        $pppcontent = $ppp.children('#ppp-content'),
        $ppptooltip = $('#ppp-tooltip'),

        zone_id = $self.closest('section').data('targetzone') !== undefined ? $self.closest('section').data('targetzone') : 0,
        $carousel = $('.carousel-' + zone_id),
        $carousel_flex = $carousel.find('.flexslider'),

        $toSlide,
        $slidePPPContent,

        $present_bar_header = $('#present-bar-header'),

        slideCount = $self.find('.slides > li').length,

        url_vars = $.Globals.getUrlVars();




      // Carousel
      if ($carousel.length > 0) {

        $.Window.on('resize.carousel-width', function() {

          // Resize flexslider container to only ever get as big as space minus prev and nex buttongs
          var new_width = $.Window.width() - 82,
            $slides = $carousel_flex.find('.slides'),
            $slide_li = $slides.find('li'),
            width_calc = $slide_li.length * (167); // <= ( item width + margin )


          // Once loaded, on resize, recalculate item width to always max out the space (no more half items)
          if ($carousel_flex !== undefined && $carousel_flex.data('flexslider') !== undefined) {

            // Reset position
            // When to center carousel items
            if (width_calc < new_width) {

              $slides.css({
                'margin-left': (width_calc / -2) + 7.5, // <= plus half of margin
                'left': '50%',
                'position': 'absolute'
              });

            } else {

              $slides.css({
                'margin-left': 0,
                'left': 'auto',
                'position': 'relative'
              });

            }

          }

        });



        // Instantiate carousel (only after flexslider container width is set)
        $carousel_flex.flexslider({
          animation: "slide",
          controlNav: false,
          animationLoop: false,
          slideshow: false,
          slideshowSpeed: 0,
          directionNav: true,
          touch: false,
          itemWidth: 152,
          itemMargin: 15,
          asNavFor: $self,
          // minItems: 		getGridSize(), // use function to pull in initial value
          // maxItems: 		getGridSize(), // use function to pull in initial value
        });


        // Run after flexslider init so we have the settings
        $.Window.trigger('resize.carousel-width');

      }


      // Slideshow
      var max = (slideCount) > 38 ? '38' : slideCount;
      $self.addClass('slide-count-' + max).flexslider({
        easing: $.Globals.fxEasing,
        animation: 'slide',
        slideshow: false,
        slideshowSpeed: 0,
        directionNav: false,
        controlNav: false,
        prevText: '',
        nextText: '',
        animationSpeed: $.Globals.fxSpeed,
        animationLoop: false,
        touch: false,
        keyboard: false,
        before: function(slider) {

          /* = VARS
          ------------------------------------------ */
          $toSlide = $(slider.slides[slider.animatingTo]);



          // Let everyone know we are sliding
          $.Globals.isSliding = true;
          $slidePPPContent = $toSlide.find('.ppp-content');

          // Close popups
          $.Globals.closePopups();

          // Determine if we should show insights or products
          $.Globals.showHideSlideProductsInsightsButtons( $toSlide );


          // console.log($slidePPPContent);
          /* = PPP
          ------------------------------------------ */
          // Update title
          $present_bar_header.empty().append($toSlide.find('.top-title').first().clone());

          if ($slidePPPContent.length > 0) {

            // remove our remove field
            $ppp.off($.Globals.transitionEnd);

            // Fade it in if it's not
            $ppp.addClass('visible');

            // Animate the PPP height
            if (window.sessionStorage.getItem('scspaces_ppp_tooltip') === null) {

              // It's never been opened before, so we need to show the tooltip
              setTimeout(function() {

                // Show it
                $ppptooltip.addClass('opened');

                // 5 seconds later close it
                setTimeout(function() {
                  $ppptooltip.removeClass('opened');
                }, 5000);

              }, 2000); // wait till everything else is loaded before we fade it in

              // Stop from showing next time
              window.sessionStorage.setItem('scspaces_ppp_tooltip', true);

            } else {

              // Hide tooltip
              $ppptooltip.removeClass('opened');

              // Close ppp content
              $.Globals.closePPP();
              $pppcontent.find('.content').removeClass('visible');

            }

          } else {

            // Not where hiding the pppcontent is handled when hitting zone slide
            $ppp.removeClass('visible').one($.Globals.transitionEnd, function() {
              $pppcontent.empty();
            });

          }



          /* = Update count
          ------------------------------------------ */
          $self.closest('.slideshow').find('.actions .current').empty().html((slider.animatingTo + 1));



          /* = URL UPDATES
          ------------------------------------------ */
          var zone = slider.closest('section').data('targetzone'),
            setting = $(slider.slides[slider.animatingTo]).data('targetslide'),
            url = 'zone=' + zone;


          // Only if we are on a zone
          if (zone !== undefined) {

            // Update url_vars
            url_vars = $.Globals.getUrlVars();

            // console.log(setting);
            url = typeof setting !== 'undefined' ? url + '&slide=' + setting : url;

            if (url_vars.s !== undefined) {
              url += '&s=' + url_vars.s;
            }


            if (parseInt(url_vars.zone, 10) !== zone || parseInt(url_vars.slide, 10) !== setting) {
              window.location.hash = url;
            }

          }

        },
        after: function(slider) {

          // Start timeout for fades
          var $theSlide = $(slider.slides[slider.animatingTo]),
            $otherLIs = $theSlide.siblings();


          // Reset first slide fade
          $otherLIs.each(function() {
            var $otherChildren = $(this).find('.background-images').children();

            if ($otherChildren.length > 1) {
              $otherChildren.first().addClass('active').stop().fadeTo(750, 1).siblings('.active').removeClass('active').css('z-index', 'auto').stop().fadeTo(750, 0);
            }

          });


          // Let everyone know we no longer sliding
          $.Globals.isSliding = false;

          // Reset our global
          $.Globals.resettingFlexsliders = false;
        },
        sync: $carousel_flex
      });

      // Hide actions if only 1 setting
      if (slideCount <= 1) {
        $self.siblings('.actions').hide();
      }



      $('#ppp').addClass('visible');


      // Force tooltip close
      $('.tooltip-force-close').one($.Globals.clickEvent + '.close-tooltip', function(e) {
        e.preventDefault();
        $ppptooltip.removeClass('opened');
      });


      $self.parent().find('.actions .prev').on($.Globals.clickEvent, function(e) {
        e.preventDefault();
        $(this).closest('.slideshow').find('.flexslider').flexslider('prev');
      });
      $self.parent().find('.actions .next').on($.Globals.clickEvent, function(e) {
        e.preventDefault();
        $(this).closest('.slideshow').find('.flexslider').flexslider('next');
      });

    });
    return this;
  };
}(jQuery));



/* ---------------------------------- */

/* ImageMap */

(function($) {
  'use strict';
  $.fn.ImageMap = function() {
    this.each(function() {

      var $self = $(this),
        $zone_image = $self.closest('.zone-image'),
        css_height = 66, // <== set height of zone-image in CSS
        $zone_content = $zone_image.siblings('.zones-content'),
        content_bottom = parseInt($('.zones-content').first().css('bottom'), 10),
        percent = 0,
        window_height = 0;


      // Center dynamically changing width image
      $.Window.on('resize.abshcenter', function() {

        // First get our window height
        window_height = $(this).height();

        // then we need our new percentage height
        percent = Math.round(((window_height - ($zone_content.height() + content_bottom + 45 + 40)) / window_height) * 100); // <= 45 is for the bar at the top of the screen; 40 is padding (20 top, 20 bottom)

        // if our CSS height is greater than our calculated height, update it
        if (css_height > percent) {

          var new_percent = Math.round(((window_height - ($zone_content.height() + content_bottom + 45 + 40)) / window_height) * 100); // <= 45 is for the bar at the top of the screen; 40 is padding
          $zone_image.height(new_percent + '%');

        } else {

          // Reset back to CSS height
          $zone_image.removeAttr('style');

        }

        // Be sure to center image
        $self.css('margin-left', -($self.width() / 2));

      });

      // Trigger resize on image load
      setTimeout(function() {

        $self.one("load.resize", function() {

          $.Window.trigger('resize.abshcenter');

        }).each(function() {
          if (this.complete) $(this).trigger('load.resize');
        });



        // Update image maps
        // $self.rwdImageMaps();

        // Custom using scale now
        // Calculate percent of original width
        $.Window.on('resize.image-maps', function() {

          var ratio = $self.width() / parseInt($self.attr('width'), 10),
            map = $self.attr('usemap').replace('#', '');

          $('map[name="' + map + '"]').find('area').each(function() {
            var $this = $(this);
            if (!$this.data('coords')) {
              $this.data('coords', $this.attr('coords'));
            }

            var coords = $this.data('coords').split(','),
              coordsPercent = new Array(coords.length);

            for (var i = 0; i < coordsPercent.length; ++i) {
              if (i % 2 === 0) {
                coordsPercent[i] = parseInt((coords[i]) * ratio);
              } else {
                coordsPercent[i] = parseInt((coords[i]) * ratio);
              }
            }
            // console.log(coordsPercent.toString());
            $this.attr('coords', coordsPercent.toString());
          });
        }).trigger('resize.image-maps');



        // $self.css({
        // 		'-webkit-transform': 'scale( ' + ratio + ' )',
        // 		'-moz-transform': 'scale( ' + ratio + ' )',
        // 		'-ms-transform': 'scale( ' + ratio + ' )',
        // 		'transform': 'scale( ' + ratio + ' )'
        // 	});

      }, 100);

    });
    return this;
  };
}(jQuery));



/* ---------------------------------- */

/* LinkFromSlideID Note: Magic. On load, converts data-toslideid to valid href link location */

(function($) {
  'use strict';
  $.fn.LinkFromSlideID = function() {
    this.each(function() {

      var $self = $(this),
        slide_id = $self.data('toslideid'),
        $target_slide = {}, // <= the second should always be the .carousel slide
        zone_id;

      // First check our current zone
      var $attempt = $self.closest('section').find('[data-targetslide="' + slide_id + '"]');
      if ($attempt.length > 0) {
        $target_slide = $attempt.first();
      } else {
        $target_slide = $('[data-targetslide="' + slide_id + '"]').first();
      }


      // Get zone from the $target_slide
      zone_id = $target_slide.closest('[data-targetzone]').data('targetzone');

      // Set attr
      if (slide_id !== undefined && zone_id !== undefined) {
        $self.attr('href', '#zone=' + zone_id + '&slide=' + slide_id);
      }

    });
    return this;
  };
}(jQuery));



/* ---------------------------------- */

/* OnePage Scroll */

(function($) {
  'use strict';
  $.fn.OneScroll = function() {
    this.each(function() {

      var $self = $(this),
        animating = false;

      $self.onepage_scroll({
        updateURL: false,
        pagination: false,
        loop: false,
        animationTime: $.Globals.scrollSpeed,
        beforeMove: function(index) {

          // Only run once per animation cycle and if we aren't actually scrolling anywhere
          // Note (+1 is because onescroll is based on a 1 based index)
          // if( ! animating ) {
          animating = true;


          // Custom update URL
          var $target = $('section').eq(index - 1);
          if ($target.length > 0) {

            // Update our URL this will automatically scroll us
            // NOTE: We are already scrolling, so just regurgitate our URL vars
            var url_vars = $.Globals.getUrlVars(),
              url = '';

            if ($target.data('targetzone') !== undefined) {

              url = 'zone=' + $target.data('targetzone');

            }

            var $targetSlide;

            if ($target.find('.flex-active-slide').length > 0) {


              $targetSlide = $target.find('.flex-active-slide');

              // This is for when we move to a different zone, and want to jump back into the slideshow
              // If we remove the setting and stay on the same zone / section, we want to not add a new setting, hence the ! hasClass('active')
              // Tied into ln #199
              url += '&slide=' + $targetSlide.data('targetslide');

              // Update header
              $.Globals.present_bar_header.empty().append($targetSlide.find('.top-title').first().clone());

            }


            if (url_vars.s !== undefined) {
              url += '&s=' + url_vars.s;
            }

            // Close carousel
            $.Globals.closePPP();
            $.Globals.closeCarouselNav();

            // Show / hide carousel
            if ($target.find('.flexslider').length > 0 && $target.find('.flexslider').find('.slides > li').length > 1) {
              $.Globals.showCarousels();
            } else {
              $.Globals.hideCarousels();
            }

            // Check if the URL has already been updated
            if (parseInt(url_vars.zone, 10) !== $target.data('targetzone') || parseInt(url_vars.slide, 10) !== $target.find('.flex-active-slide').data('targetslide')) {
              window.location.hash = url;
            }
          }

          setTimeout(function() {
            animating = false;
          }, $.Globals.scrollSpeed);
          // }


        },
        afterMove: function() {}
      });

      // If only 1 section, do basic initialization
      if ($self.find('section').length === 1) {

        var $target = $self.find('section');

        // Show / hide carousel
        if ($target.find('.flexslider li').length > 1) {
          $.Globals.showCarousels();
        } else {
          $.Globals.hideCarousels();
        }

      }

    });
    return this;
  };
}(jQuery));



/* ---------------------------------- */

/* OpenMenu */

(function($) {
  'use strict';
  $.fn.OpenMenu = function() {
    this.each(function() {

      var $self = $(this),
        theClass = $self.data('class');
      // in_menu_collection_template = $('#in-menu-collection-mst').html(),
      // output;


      $self.on($.Globals.clickEvent + '.av', function(e) {
        e.preventDefault();

        // Close the other menu
        if (theClass === 'primary') {
          $.Body.removeClass('open-personal-menu');
        } else if (theClass === 'personal') {
          $.Body.removeClass('open-primary-menu');

          // Remove previously set in menu collection if it exists
          $('#personal-menu .personal-in-menu-collection').remove();

          // Add collection to menu if it exists
          // var in_menu_collection = $.Globals.getMenuCollectionItem();
          // console.log(in_menu_collection);
          // if( in_menu_collection && in_menu_collection.id !== undefined ) {
          //
          // 	// Build our collection
          // 	in_menu_collection.edit_url = in_menu_collection.url + 'edit/';
          // 	in_menu_collection.presentation_url = in_menu_collection.url + 'present/';
          //
          //
          // 	Mustache.parse( in_menu_collection_template );
          // 	output = Mustache.render( in_menu_collection_template, in_menu_collection );
          // 	$.Globals.myCollectionsMenuItem.before( output );
          //
          // }


          // Check options: Overlay Help
          if (window.localStorage.getItem('scspaces_overlay_help_on') === null) { // <= localstorage converts boolean to string
            $('#overlay-help-off-option').addClass('active');
          } else {
            $('#overlay-help-off-option').removeClass('active');
          }

        }


        // open or close our menu
        $.Body.toggleClass('open-' + theClass + '-menu');


        // Reset primary menu
        // resetNav();


        // Setup close (wait for animation to finish)
        setTimeout(function() {
          $.Body.on($.Globals.clickEvent + '.close-nav', function(e) {
            var $target = $(e.target);

            // Only close if:
            // not clicking on a menu item
            // not clicking on overlay close
            if ($target.parents('nav').length === 0 && $target.attr('id') !== 'close-overlay') {

              // Remove the body class
              $(this).removeClass('open-' + theClass + '-menu');

              // Reset primary menu
              // resetNav();

              $.Body.off($.Globals.clickEvent + '.av');
            }
          });
        }, $.Globals.navFXSpeed);

      });

    });
    return this;
  };
}(jQuery));



/* ---------------------------------- */

/* CloseMenus */

(function($) {
  'use strict';
  $.fn.CloseMenu = function() {
    this.each(function() {

      $(this)
        .removeClass('open-primary-menu')
        .removeClass('open-personal-menu');

    });
    return this;
  };
}(jQuery));





/* ---------------------------------- */

/* OpenClose PPP and Views */

(function($) {
  'use strict';
  $.fn.OpenClose = function() {
    this.each(function() {

      var $this = $(this),
        $container = $this.siblings('.oc-content'),
        is_ppp = this.id === 'ppp-trigger',
        $ppp_tooltip = $('#ppp-tooltip');

      $this.on($.Globals.clickEvent, function(e) {
        e.preventDefault();

        // If we are currently sliding don't trigger PPP
        // we need to wait for after() to run so new content is in the ppp
        if ($.Globals.isSliding) return;

        // No matter what, close the tooltip
        $ppp_tooltip.removeClass('opened');

        if ( ! $container.hasClass('opened') ) {

          $container.addClass('opened');
          if (is_ppp) {

            $('#views-content').removeClass('opened');
            $container.find('.content').addClass('visible'); // ensure it's content is visible
            window.sessionStorage.setItem('scspaces_ppp_tooltip', true);

          } else {

            // close ppp if its open
            $.Globals.closePPP();

          }

        } else {

          $container.removeClass('opened');
          if (is_ppp) {
            window.sessionStorage.setItem('scspaces_ppp_tooltip', true);
          }

        }

        // Listen for click anywhere else to close
        $.Document.off($.Globals.clickEvent + '.close-click').on($.Globals.clickEvent + '.close-click', function(e) {

          if ($(e.target).parents('.open-close-box').length === 0) {
            $('.oc-content.opened').siblings('.oc-trigger').trigger($.Globals.clickEvent);
          }

        });

      });


      // Only if PPP
      if (is_ppp) {

        // Handle product accordion here too
        $.Document.on($.Globals.clickEvent, '#ppp-content .trigger-ppp-products', function(e) {
          e.preventDefault();

          var $this = $(this),
            $content = $this.closest('.content'),
            $descriptionHolder = $content.find('.description-accordion'),
            $productsHolder = $content.find('.products_holder'),
            productsFutureHeight = 0,
            descriptionFutureHeight = 0;

          if ($this.hasClass('open')) { // <= close it

            productsFutureHeight = 0;
            $this.removeClass('open');
            // $this.closest('.ppp-content').removeClass('open-products');
            $this.closest('#ppp-content').removeClass('open-products');


            $descriptionHolder.height('auto');
            descriptionFutureHeight = $descriptionHolder.height();
            $descriptionHolder.height(20);

          } else { // <= open it

            $this.addClass('open');

            // Jump open to measure future height
            $productsHolder.height('auto');
            productsFutureHeight = $productsHolder.height();
            $productsHolder.height(0);


            descriptionFutureHeight = 20;

            // Add class
            // $this.closest('.ppp-content').addClass('open-products');
            $this.closest('#ppp-content').addClass('open-products');


          }

          // Update ppp height
          $productsHolder.animate({
            height: productsFutureHeight,
          }, $.Globals.fxSpeed);


          $descriptionHolder.animate({
            height: descriptionFutureHeight,
          }, $.Globals.fxSpeed);

        });

      } else {

        // Handle product accordion here too
        $.Document.on($.Globals.clickEvent, '#views-content li > a', function(e) {
          e.preventDefault();

          var $this = $(this),
            trigger_id = $this.data('triggerview'),
            $current_slide = $('.slides > .slide-' + $this.closest('ul').data('slide')),
            $all_views = $current_slide.find('.views > .background-images'),
            $current_view = $current_slide.find('.views > .view-' + trigger_id),
            $ppp_products = $('#ppp .products');

          // Activate this item
          $this.parent().addClass('active').siblings().removeClass('active');

          // Show view: CSS (not working in MS Edge)
          // $current_view.addClass('active').siblings().removeClass('active');

          // Show view: JS (for MS Edge)
          $all_views.not($current_view).css('z-index', 1).stop().fadeTo(750, 0);
          $current_view.addClass('active').stop().fadeTo(750, 1);

          // Hide products if not first
          if (trigger_id !== 0) {
            $ppp_products.hide();
          } else {
            $ppp_products.show();
          }

        });

      }

    });
    return this;
  };
}(jQuery));




/* ---------------------------------- */

/* OverlayHelpOption */

(function($) {
  'use strict';
  $.fn.OverlayHelpOption = function() {
    this.each(function() {

      var $this = $(this);
      $this.on($.Globals.clickEvent, function(e) {

        e.preventDefault();
        e.stopPropagation();

        if ($this.hasClass('active')) {

          $this.removeClass('active');
          window.localStorage.setItem('scspaces_overlay_help_on', false);

        } else {

          $this.addClass('active');
          window.localStorage.removeItem('scspaces_overlay_help_on');

        }

      });

    });
    return this;
  };
}(jQuery));



/* ---------------------------------- */

/* ScrollTo */

(function($) {
  'use strict';
  $.fn.ScrollTo = function(animate) {
    this.each(function() {

      if ($('[data-controller="OneScroll"]').length > 0) {

        var $self = $(this);

        // Set default for animate
        animate = typeof animate !== 'undefined' ? animate : true;

        // Scroll to the element
        $('[data-controller="OneScroll"]').moveTo($self.index('section') + 1);

        // Close menu if it's open
        $.Body.CloseMenu();

      }

    });
    return this;
  };
}(jQuery));




/* ---------------------------------- */

/* OpenPrimaryMenu */

(function($) {
  'use strict';
  $.fn.SlideoutMenu = function() {
    this.each(function() {

      // Handle Nav Slide Clicks (Have to listen for new dom objects because of "My Collections" menu)
      $.Document.on($.Globals.clickEvent, '.slideout-menu a', function(e) {


        // Calculate next scrollto
        var $this = $(this),
          $parentUL = $this.closest('ul'),
          $parentLI = $this.closest('li'),
          $targetUL = $('#menu-' + $this.data('menu'));


        // Move our old one out only if it exists, otherwise return
        if ($targetUL.length > 0) {

          e.preventDefault();

          // Fade in new navigation
          $parentUL.fadeOut($.Globals.navFXSpeed, function() {
            $targetUL.fadeIn($.Globals.navFXSpeed);
          });


        } else if ($parentLI.hasClass('zone')) {


          // If we are just adding a hash the page will not reload / no scroll
          // $.Globals.scrollToSectionFromVars( $this.attr('href') );

        }

      });


    });
    return this;
  };
}(jQuery));



/* ---------------------------------- */

/* UserGuideTrigger */

(function($) {
  'use strict';
  $.fn.UserGuideTrigger = function() {
    this.each(function() {

      var $self = $(this);

      $self.on($.Globals.clickEvent, function(e) {
        e.preventDefault();

        // Update check
        if (window.localStorage.getItem('scspaces_overlay_help_on') !== 'false') {
          // Activate checkbox
          $('#overlay-help-off-option').addClass('active');
        } else {
          $('#overlay-help-off-option').removeClass('active');
        }

        $.Body.trigger($.Globals.clickEvent + '.av').addClass('overlay-help-on');

      });

    });
    return this;
  };
}(jQuery));


/* ---------------------------------- */

/* ToggleDropdown */

(function($) {
  'use strict';
  $.fn.ToggleDropdown = function() {
    this.each(function() {

      $(this).on($.Globals.clickEvent, function(e) {
        e.preventDefault();

        var $this_parent = $(this).parent();

        // If others are open, close them
        $('.open-dropdown').not($this_parent).removeClass('open-dropdown');

        $this_parent.toggleClass('open-dropdown');

        // Global close listener
        $.Document.off($.Globals.clickEvent + '.global-langmenu-close').on($.Globals.clickEvent + '.global-langmenu-close', function(e) { // <= global listen for close popup

          // Exceptions
          if ($('.personal-nav .open-dropdown').length === 0) return;
          if ($(e.target).closest('.open-dropdown').length > 0) return;

          // Close it
          $this_parent.toggleClass('open-dropdown');

        });

      });
    });
    return this;
  };
}(jQuery));




/* ---------------------------------- */

/* TriggerScroll */

(function($) {
  'use strict';
  $.fn.TriggerScroll = function() {
    this.each(function() {

      var $self = $(this),
        direction = $self.data('direction');

      $self.on($.Globals.clickEvent, function(e) {
        e.preventDefault();

        var $current_section = $('section.active'),
          $target;

        // Calculate next scrollto
        if (direction === 'down') {
          $target = $current_section.next('section');
        } else {
          $target = $current_section.prev('section');
        }

        if ($target.length > 0) {

          var zone_id = $target.data('targetzone'),
            slide_id = $target.children('.flexslider').find('.slides > li').first().data('targetslide');

          // Update our URL this will automatically scroll us
          if (zone_id !== undefined && slide_id !== undefined) {

            window.location.hash = 'zone=' + zone_id + '&slide=' + slide_id;

          }

        }

      });

    });
    return this;
  };
}(jQuery));



/* ---------------------------------- */

/* Global Prototypes */

if (!Array.prototype.indexOfByProperty) {
  Array.prototype.indexOfByProperty = function(prop, value) {
    for (var index = 0; index < this.length; index++) {
      if (this[index][prop]) {
        if (this[index][prop] === value) {
          return index;
        }
      }
    }
    return -1;
  };
}
